
import NotSupportedAPI from "../../pages/NotSupportedAPI"
import { createDescriptor, PageDescriptor } from "../../pages/types"
import { ApplicationBrick, ApplicationLicense } from "./ApplicationBrick"

export class CApplicationBrick extends ApplicationBrick {
    constructor(license: ApplicationLicense, readonly os: string, framework: string, packageManager: string, isContainer: boolean, isOrchestrated: boolean) {
        super(license, 'c', framework, packageManager, isContainer, isOrchestrated)
    }

    public key(): string { 
        return 'app-c'
    }

    *getPages(): Generator<PageDescriptor> {
        yield createDescriptor(NotSupportedAPI, { api: 'C' })
    }
}